import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export interface ContainerProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  spacing?: 'sm' | 'md' | 'lg' | 'xl';
}

export default function Container({
  size = 'sm',
  spacing = 'md',
  className,
  children,
  ...props
}: ContainerProps) {

  return (
    <div
      className={classNames(
        'mx-auto px-6 sm:px-8',
        size === 'sm' && 'max-w-2xl',
        size === 'md' && 'max-w-screen-lg',
        size === 'lg' && 'max-w-screen-xl',
        spacing === 'sm' && 'py-4 sm:py-6 space-y-4 sm:space-y-6',
        spacing === 'md' && 'py-8 sm:py-10 space-y-8 sm:space-y-10',
        spacing === 'lg' && 'py-12 sm:py-14 space-y-12 sm:space-y-14',
        spacing === 'xl' && 'py-20 sm:py-28 space-y-12 sm:space-y-14',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
